// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { createHandoffHandoff } from "./handoff.js";
export const createHandoffExtensions = (client) => createHandoffHandoff(client);
export const handoffOperations = [
    { method: "GET", path: "/handoff/seller-contact", accessor: "handoff.retrieveSellerContact" },
    { method: "POST", path: "/handoff/tally/ingest", accessor: "handoff.updateTallyIngest" },
    { method: "POST", path: "/handoff/vendor-quote-approval", accessor: "handoff.updateVendorQuoteApproval" },
];
//# sourceMappingURL=index.js.map